import { TableCell, Typography } from '@mui/material';

import { EXPANDED_CELL_SX } from '../coverage-rating/list-detail/rater.coverage.list.expanded.cells';
import { PropsOf } from '@emotion/react';
import { forwardRef } from 'react';

export const RaterCoverageListTableHeaderCell = ({
  children,
  expanded,
  sx = {},
  ...props
}: PropsOf<typeof TableCell> & { expanded?: boolean }) => {
  return (
    <TableCell
      sx={expanded ? { ...sx, ...EXPANDED_CELL_SX } : undefined}
      {...props}
    >
      {typeof children === 'string' ? (
        <RaterCoverageListTableHeaderCell.Typography>
          {children}
        </RaterCoverageListTableHeaderCell.Typography>
      ) : (
        children
      )}
    </TableCell>
  );
};

RaterCoverageListTableHeaderCell.Typography = forwardRef<
  HTMLSpanElement,
  { children: string }
>(
  (
    {
      children,
    }: {
      children: string;
    },
    ref
  ) => {
    return (
      <Typography fontWeight={600} fontSize="14px" ref={ref}>
        {children}
      </Typography>
    );
  }
);
